import { app } from './../app.world';
import { FW } from './../framework/Framework';
import { BaseScreen } from './BaseScreen';

export class AboutScreen extends BaseScreen {

    private _sprite:GAF.GAFMovieClip;

    constructor() {
        super();

        this._sprite = FW.gafManager.createMovieClip('worlds', 'lib_about_screen');
        FW.root.addChild(this._sprite);

        this.setupButton(this._sprite['buttonBack'], () => {
            app.showCover();
        }, 'Back');
    }

    public get sprite():GAF.GAFMovieClip {
        return this._sprite;
    }

}


// WEBPACK FOOTER //
// ./src/worlds/AboutScreen.ts